import "./App.css";
import Navbar from "./Navbar/Navbar";
import Shop from "./Shop/Shop";

function App() {
  return (
    <>
      <Navbar />
      <Shop />
    </>
  );
}

export default App;
